'use client'

import { useState } from 'react'

import { LuEye, LuEyeOff } from 'react-icons/lu'

import { Input } from '@ui/components/shadcn/ui/input'

import { BaseFieldProps, FieldShell } from './FieldShell'

export function PasswordField({
  autoComplete = 'current-password',
  ...shell
}: BaseFieldProps & {
  autoComplete?: 'current-password' | 'new-password'
}) {
  const [visible, setVisible] = useState(false)
  return (
    <FieldShell<string> {...shell}>
      {({ field, controlProps }) => (
        <div className="relative">
          <Input
            {...controlProps}
            type={visible ? 'text' : 'password'}
            autoComplete={autoComplete}
            className="pr-10"
            value={field.state.value}
            onChange={(event) => field.handleChange(event.target.value)}
            onBlur={field.handleBlur}
          />
          <button
            type="button"
            aria-label={visible ? 'Hide password' : 'Show password'}
            className="text-muted-foreground absolute inset-y-0 right-0 flex items-center pr-3"
            onClick={() => setVisible((current) => !current)}
          >
            {visible ? <LuEyeOff /> : <LuEye />}
          </button>
        </div>
      )}
    </FieldShell>
  )
}
